import React from 'react'
import './LeaveTracker.css'
const LeaveTracker = () => {
  return (
    <div>
      <h1>LeaveTracker</h1>
    </div>
  )
}

export default LeaveTracker
